// TypingDots.jsx
import React from 'react';
import { Box, keyframes } from '@mui/material';

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
  } 
  40% {
    transform: scale(1);
  }
`;

const TypingDots = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.5,
        pl: 1,
        pt: 0.5,
        pb: 0.5,
      }}
    >
      {[0, 1, 2].map((dot, i) => (
        <Box
          key={i}
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            bgcolor: 'grey.500',
            animation: `${bounce} 1.4s infinite ease-in-out`,
            animationDelay: `${i * 0.2}s`,
          }}
        />
      ))}
    </Box>
  );
};

export default TypingDots;
